import React from 'react';
import AudiobookCalculator from './components/AudiobookCalculator';
import './styles/App.css';

const App = () => {
  return (
    <div className="App">
      <AudiobookCalculator />
    </div>
  );
};

export default App;
